module.exports = __webpack_public_path__ + "static/media/kitchen1.f9029983.jpg";